import { USER_NOT_SIGNED_IN_ERROR_MSG } from 'utils/constants/errors';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { toDateFormat } from 'utils/helpers/timestampHelper';
import { ASSESSMENTS } from 'utils/constants/collectionNames';
import {
  GET_ASSESSMENTS_SUCCEED,
  GET_ASSESSMENTS_ERROR,
  GET_ASSESSMENT_SUCCEED,
  GET_ASSESSMENT_ERROR,
  CREATE_ASSESSMENT_SUCCEEDED,
  CREATE_ASSESSMENT_ERROR,
  UPDATE_ASSESSMENT_SUCCEEDED,
  UPDATE_ASSESSMENT_ERROR,
  LOADING_STATE
} from './Types';

// get client from Firebase
export const getAssessments = clientId => async dispatch => {
  try {
    let firestore = firebase.firestore();

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        dispatch({ type: LOADING_STATE });
        let queryRef = firestore
          .collection(ASSESSMENTS)
          .where('trainer_id', '==', user.uid)
          .where('client_id', '==', clientId);
        return queryRef.get().then(querySnapshot => {
          let assessments = [];
          if (querySnapshot.docs.length > 0) {
            querySnapshot.forEach(function(doc) {
              assessments.push({
                ...doc.data(),
                id: doc.id
              });
            });
            dispatch({ type: GET_ASSESSMENTS_SUCCEED, payload: assessments });
          } else {
            dispatch({ type: GET_ASSESSMENTS_SUCCEED, payload: [] });
          }
        });
      } else {
        throw new Error(USER_NOT_SIGNED_IN_ERROR_MSG);
      }
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: GET_ASSESSMENTS_ERROR,
      payload: `error: ${err}`
    });
  }
};
export const getAssessment = (assessmentId, history) => async dispatch => {
  let firestore = firebase.firestore();
  let docRef = firestore.collection(ASSESSMENTS).doc(assessmentId);
  docRef
    .get()
    .then(function(doc) {
      if (doc.exists) {
        dispatch({
          type: GET_ASSESSMENT_SUCCEED,
          payload: {
            ...doc.data(),
            birthday: toDateFormat(doc.data().birthday),
            id: doc.id
          }
        });
      } else {
        console.log('This Assessment is not exist!');
        history.replace('/event-not-found');
      }
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: GET_ASSESSMENT_ERROR,
        payload: `error: ${error}`
      });
      history.replace('/event-not-found');
    });
};

// create assessment
export const createAssessment = (assessment, history) => async dispatch => {
  let firestore = firebase.firestore();
  var docRef = firestore.collection(ASSESSMENTS);

  firebase.auth().onAuthStateChanged(user => {
    if (user) {
      assessment.created_at = new Date();
      assessment.trainer_id = user.uid;

      docRef
        .add(assessment)
        .then(function(doc) {
          history.push(
            `/clients/${assessment.client_id}/assessments/${doc.id}`
          );
          return dispatch({
            type: CREATE_ASSESSMENT_SUCCEEDED
          });
        })
        .catch(function(error) {
          console.log(error);
          dispatch({
            type: CREATE_ASSESSMENT_ERROR,
            payload: `error: ${error}`
          });
        });
    } else {
      dispatch({
        type: CREATE_ASSESSMENT_ERROR,
        payload: `error: ${USER_NOT_SIGNED_IN_ERROR_MSG}`
      });
    }
  });
};

// update assessment
export const updateAssessment = (assessment, history) => async dispatch => {
  let firestore = firebase.firestore();
  const assessmentId = assessment.id;
  delete assessment.id;
  var docRef = firestore.collection(ASSESSMENTS).doc(assessmentId);

  docRef
    .update(assessment)
    .then(() => {
      history.push(
        `/clients/${assessment.client_id}/assessments/${assessmentId}`
      );
      return dispatch({
        type: UPDATE_ASSESSMENT_SUCCEEDED
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: UPDATE_ASSESSMENT_ERROR,
        payload: `error: ${error}`
      });
    });
};
